module.exports = __webpack_public_path__ + "img/stores1.8edf6431.png";